export const USER_GUEST = '/user/guest/' as const
export const USER_GUEST_ALL = `${USER_GUEST}all` as const
